import React from "react";
import { Redirect } from "react-router-dom";
import cookies from "js-cookie";
import { mangerPages } from "components/common";
import $ from "jquery";
import { baseUrl } from "utils";

const pages = {
  prefix: "/mymymanager",
  // eslint-disable-next-line no-unused-vars,react/display-name
  init: ({ user, ...args }) => {
    // console.log('init args', args)
    if (!user.self.qingyan) {
      return <Redirect to="/index" />;
    }
    return null;
  },
  pages: mangerPages,
  startPage: ""
};
if (window.location.pathname.indexOf("/mymymanager") !== -1) {
  $.ajax({
    url: baseUrl + "/usr/menu",
    async: false,
    withCredentials: true,
    data: {
      token: cookies.get("adminShorcuts"),
      roleId: cookies.get("adminRoleId")
    },
    success: data => {
      data.map(x => {
        return pages.pages.filter(y => {
          if (x.name === y.name) {
            if (x.name === "工作台" && x.menus) {
              sessionStorage.setItem("workRole", JSON.stringify(x.menus));
            }
            delete y.noNav;
            y.children.map((z, index) => {
              if (x.menus) {
                const arrNames = x.menus.map(it => it.name);
                if (x.menus[index] && x.menus[index].name === z.name) {
                  if (x.menus[index].menus) {
                    sessionStorage.setItem(
                      "payRole",
                      JSON.stringify(x.menus[index].menus)
                    );
                  }
                  // delete z.noNav;
                }
                if (arrNames.includes(z.name)) {
                  delete z.noNav;
                }
              }
              return z;
            });
          }
          return y;
        });
      });
    }
  });
}
export default pages;
